import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import {PopupService} from "../../../services/popup.service";
import {BaseService} from "../../../services/base.service";

@Component({
  selector: 'app-contact-support',
  templateUrl: './contact-support.component.html',
  styleUrls: ['./contact-support.component.less'],
  encapsulation: ViewEncapsulation.None
})
export class ContactSupportComponent implements OnInit {

  constructor(public popupService: PopupService, public baseService: BaseService) { }

  ngOnInit() {
  }

  closePopup() {
    this.popupService.updateRoute();
  }

}



// WEBPACK FOOTER //
// ./src/app/components/popups/contact-support/contact-support.component.ts